import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fa7dc41c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auth" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sign_in_form = _resolveComponent("sign-in-form")!
  const _component_restore_form = _resolveComponent("restore-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.is_on_sign_in)
      ? (_openBlock(), _createBlock(_component_sign_in_form, {
          key: 0,
          loading: _ctx.state.is_loading,
          onRestore: _ctx.toggleRestore,
          onSubmit: _ctx.signInHandler
        }, null, 8, ["loading", "onRestore", "onSubmit"]))
      : (_openBlock(), _createBlock(_component_restore_form, {
          key: 1,
          loading: _ctx.state.is_loading,
          onCancel: _ctx.toggleRestore,
          onDone: _ctx.toggleRestore
        }, null, 8, ["loading", "onCancel", "onDone"]))
  ]))
}